/* eslint-disable import/no-deprecated */
import React, { PropsWithChildren } from 'react';
import { Typography } from '../../deprecated/Typography';
import { Box } from '../Box';
import { Flex } from '../Flex';
import { Pane } from '../Pane';

/**
 * This file contains components that are helpful for creating nicely organized and styled stories.
 */
export const Story: React.FC<
  PropsWithChildren<{
    title?: string;
    description?: string;
  }>
> = ({ title, description, children }) => (
  <Box data-component="Story" padding={16}>
    <Flex column alignItems="flex-start">
      <Typography variant="heading1">{title}</Typography>
      <Typography variant="body3">{description}</Typography>
      <Pane
        marginTop={8}
        padding={16}
        backgroundColor="default"
        borderRadius={4}
        width="100%"
        border="standard"
      >
        {children}
      </Pane>
    </Flex>
  </Box>
);
